import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import sessionStorage from 'redux-persist/lib/storage/session'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import activeUserReducer from './reducers/activeUser'
import rooms from './reducers/RoomsReducer'
import websocketConnection from './reducers/websocketConnection'
import activeGame from './reducers/activeGame'
import registeringUser from './reducers/registeringUser'
import appConfig from './reducers/AppConfig'
import profileData from './reducers/ProfileDataReducer'
import publicUser from './reducers/PublicUserReducer'
import events from './reducers/EventsReducer'

const reducer = combineReducers({
	activeUser: persistReducer({ key: 'ActiveUser', storage }, activeUserReducer),
	profileData,
	rooms,
	websocketConnection,
	activeGame,
	registeringUser,
	appConfig,
	publicUser,
	events,
})

export const store = configureStore({
	reducer: persistReducer({ key: 'root', storage: sessionStorage, blacklist: ['websocketConnection'] }, reducer),
	devTools: process.env.NODE_ENV !== 'production',
	middleware: [thunk],
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
